var React = require('react');

function Graph (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.75 1C18.3358 1 18 1.3961 18 1.88462V23.1154C18 23.6039 18.3358 24 18.75 24H23.25C23.6642 24 24 23.6039 24 23.1154V1.88462C24 1.3961 23.6642 1 23.25 1H18.75Z","fill":"#2665F6","key":0}),React.createElement("path",{"d":"M10.75 7C10.3358 7 10 7.40063 10 7.89474V23.1053C10 23.5994 10.3358 24 10.75 24H15.25C15.6642 24 16 23.5994 16 23.1053V7.89474C16 7.40063 15.6642 7 15.25 7H10.75Z","fill":"#2665F6","key":1}),React.createElement("path",{"d":"M2.75 13C2.33582 13 2 13.3789 2 13.8462V23.1538C2 23.6211 2.33582 24 2.75 24H7.25C7.66418 24 8 23.6211 8 23.1538V13.8462C8 13.3789 7.66418 13 7.25 13H2.75Z","fill":"#2665F6","key":2})]);
}

Graph.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = Graph;

Graph.default = Graph;
